export default __webpack_public_path__ + "static/media/regulatory--turn-left-or-right--g1.89ad6968.png";